import Flickity from 'flickity';

export default class DynamicSlideshow {
  constructor(section) {
    this.el = section.el;
    this.$el = $(this.el);
    this.slideshow = this.el.querySelector('[data-slideshow]');
    this.flickity = null;
    this.slideCount = Number(this.slideshow.getAttribute('data-slideshow-slides'));
    this.autoplay = section.data.autoplay ? section.data.autoplay : null;

    this.autoplayHoverPause = this.autoplay ? section.data.autoplayHoverPause : false;
    this.autoplayDelay = this.autoplay ? section.data.autoplayDelay * 1000 : null;
    this._resizeFlickity = this._resizeFlickity.bind(this);
    this._setupSlideshow();
  }

  onSectionUnload() {
    if (this.flickity) {
      this.slideshow.removeEventListener('rimg:load', this._resizeFlickity);
      this.flickity.destroy();
      this.flickity = null;
    }
  }

  onSectionBlockSelect(block) {
    if (!this.flickity) { return; }
    const slideIndex = parseInt($(block.el).data('slide-index'), 10);
    this.flickity.select(slideIndex, true);
    if (this.autoplay) {
      this.flickity.stopPlayer();
    }
  }

  onSectionBlockDeselect(block) {
    if (this.autoplay) {
      this.flickity.playPlayer();
    }
  }

  _setupSlideshow() {
    let slideshowNavigation = true;
    let slideshowPagination = true;
    let draggable = true;

    if (this.slideCount === 1) {
      slideshowNavigation = false;
      slideshowPagination = false;
      draggable = false;
    }

    this.flickity = new Flickity(this.slideshow, {
      adaptiveHeight: true,
      autoPlay: this.autoplayDelay,
      cellSelector: '[data-slideshow-slide]',
      pageDots: slideshowPagination,
      pauseAutoPlayOnHover: this.autoplayHoverPause,
      prevNextButtons: slideshowNavigation,
      resize: true,
      wrapAround: true,
      draggable,
    });
    this.slideshow.addEventListener('rimg:load', this._resizeFlickity);
  }

  _resizeFlickity() {
    if (this.flickity) {
      this.flickity.resize();
    }
  }
}
